import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawTextArea, type RawTextAreaProps } from './RawTextArea'

export type TextAreaProps = RawTextAreaProps & InputProps

export const TextArea = ({ wrapperProps, ...fieldProps }: TextAreaProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawTextArea {...fieldProps} id={id} />
    </InputWrapper>
  )
}
